export enum AppRoute {
  LOGIN = "/login",
  REGISTER = "/register",
  FORGOT_PASSWORD = "/forgot-password",
  CHANGE_EMAIL = "/change-email",
  RESET_PASSWORD = "/reset-password",
  CHANGE_PASSWORD = "/change-password",
  VERIFY_EMAIL = "/verify-email",
  USER_EMAIL_VERIFY = "/user-email-verify",

  DASHBOARD = "/dashboard",
  HOME = "/dashboard/home",
  DEVICES = "/dashboard/devices",
  HISTORY = "/dashboard/history",
  DLB = "/dashboard/dlb",
  BILLING = "/dashboard/billing",
  USERS = "/dashboard/users",
  PROFILE_DETAILS = "/dashboard/profile-details",
  THEME = "/dashboard/theme",
  NOT_FOUND = "/dashboard/*",

  UNAUTHORIZED = "/unauthorized",
}
